<template>
  <div class="vh-100">
    <v-row v-if="!isLoaded" align-center justify-center fill-height>
      <v-overlay>
        <v-progress-circular
          :size="70"
          :width="7"
          color="purple"
          indeterminate
        ></v-progress-circular>
      </v-overlay>
    </v-row>
    <router-view v-else />
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import firebase from "firebase";
import { db, projectId } from "@/firebase";
import { goPanel } from "@/utils/router.js";

export default {
  name: "App",
  data() {
    return {
      noAdmin: true,
      loadingLogout: false,
    };
  },
  computed: {
    //noAdmin: this.role ? (this.role != "admin") : false,
    snackbar: {
      get() {
        return this.$store.state.snackbar.show;
      },
      set(value) {
        this.$store.commit("snackbar/reset");
      },
    },
    ...mapGetters({
      role: "auth/role",
    }),
    ...mapState({
      isLogged: (state) => state.auth.isLogged,
      isLoaded: (state) => state.loaded,
      snackbar_text: (state) => state.snackbar.text,
      snackbar_color: (state) => state.snackbar.color,
    }),
  },
  methods: {},
  mounted() {
    if (projectId == "fun-eat") {
      this.$store.commit("app/setModoDesarrollo", "desarrollo");
    } else if (projectId == "fun-eat-produccion") {
      this.$store.commit("app/setModoDesarrollo", "produccion");
    }
    let _vm = this;
    firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        db.collection("users")
          .doc(user.uid)
          .get()
          .then((doc) => {
            let user_db = {};
            if (doc.exists) {
              user_db = doc.data();
            }
            //reducir el objeto user a lo necesario
            var array_promesas = [];
            let user_combinado = { ...user, ...user_db };
            _vm.$store.commit("auth/setUser", user_combinado);
            if (_vm.role == "admin") {
              //let p_users_auth = _vm.$store.dispatch('users/getUsuariosCall');
              let p_admin = _vm.$store.dispatch("loading/getAdmin");
              array_promesas.push(p_admin);
            } else if (_vm.role == "boss_restaurante") {
            } else if (_vm.role == "boss_negocio") {
              //alert("negocio");
              //let p_negocio = _vm.$store.dispatch("loading/getBossNegocio");
              //array_promesas.push(p_negocio);
              //this.$router.push(goPanel());
            }
            return Promise.all(array_promesas).then((r) => {});
          })
          .finally(() => {
            _vm.$store.commit("setLoaded", true);
          });
      } else {
        _vm.$store.commit("setLoaded", true);
        // _vm.$router.push("/login");
        //location.reload();
      }
    });
  },
};
</script>
<style>
.vh-100 {
  height: 100vh;
}
.theme--light.v-application {
  background: #eceff1 !important;
  color: rgba(0, 0, 0, 0.87);
}
</style>
